import * as idEndpoints from './id';
import { root, id } from './trials';

export const trials = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
